export default {
  headerContent: {
    title: 'HDI Sigorta Konut (Ev) Sigortası Fiyatları',
    slogan: "Konut Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'KONUT SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'HDI Sigorta Konut Sigortası',
    description: {
      title: 'HDI Sigorta Konut Sigortası (Ev Sigortası) Nedir?',
      content: [
        'Konut sigortası, konut ve konut içerisinde bulanan eşyalarda oluşabilecek risklere karşı güvence sağlamaktadır.',
        'Konut sigortası yangın, hırsızlık ve deprem gibi risklerin oluşması sonucu oluşacak maddi kayıplara karşı sigortalıyı güvence altına almaktadır.'
      ]
    },
    subContent: {
      title: 'HDI Sigorta Konut Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Konut sigortası teminatları ana ve ek olmak üzere 2’ye ayrılmaktadır.',
          subList: null
        },
        {
          paragraph: '<strong>Ana Teminatlar;</strong>',
          subList: [
            'Yangın, Yıldırım, İnfilak',
            'Yangın Mali Mesuliyet',
            'Cam Kırılması Teminatıdır.'
          ]
        },
        {
          paragraph: '<strong>Ek Teminatlar;</strong>',
          subList: [
            'Dahili Su Basması',
            'Sel Su Baskını',
            'Kar Ağırlığı',
            'Yer Kayması',
            'Duman',
            'Grev, Lokavt, Kargaşalık ve Halk Hareketleri',
            'Kötü Niyetli Hareketler',
            'Terörizm',
            'Enkaz Kaldırma Masrafları',
            'Kara Taşıtları Çarpması',
            'Hava Taşıtları Çarpması Teminatıdır.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Konut Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Konut Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Konut Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Konut Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Konut Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'HDI Sigorta Konut Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
